import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  signup: (userData) => api.post('/api/auth/signup', userData),
  login: (credentials) => api.post('/api/auth/login', credentials),
  getProfile: () => api.get('/api/auth/profile'),
};

export const chatAPI = {
  sendMessage: (model, data) => api.post(`/api/chat/${model}`, data),
  getChatHistory: () => api.get('/api/chat/history'),
  getChat: (chatId) => api.get(`/api/chat/${chatId}`),
  deleteChat: (chatId) => api.delete(`/api/chat/${chatId}`),
};

export const userAPI = {
  getTokens: () => api.get('/api/user/tokens'),
  getProfile: () => api.get('/api/user/profile'),
};

export const uploadAPI = {
  uploadFiles: (files) => {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file);
    });
    return api.post('/api/upload/files', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  deleteFile: (filename) => api.delete(`/api/upload/file/${filename}`),
  getFileInfo: (filename) => api.get(`/api/upload/info/${filename}`),
  getFileUrl: (filename) => `${api.defaults.baseURL}/api/upload/file/${filename}`
};

export default api;
